import { createSlice } from '@reduxjs/toolkit';

// Default configuration values
const initialState = {
  position: 'top-right', // top-right, top-center, top-left, bottom-right, bottom-center, bottom-left
  maxToasts: 5,          // Maximum number of toasts to show at once
  defaultDurations: {    // Default durations in ms for each toast type
    success: 3000,
    error: 5000,
    warning: 4000,
    info: 3000
  },
  pauseOnHover: true,    // Pause toast countdown when hovering
  dismissible: true,     // Allow manual dismissal with close button
  preventDuplicates: true, // Prevent duplicate toasts
  newestOnTop: true,     // Show newest toasts on top
  rtl: false,            // Right-to-left support
};

const toastConfigSlice = createSlice({
  name: 'toastConfig',
  initialState,
  reducers: {
    updateToastConfig: (state, action) => {
      // Update only the provided fields, maintain defaults for the rest
      return { ...state, ...action.payload };
    },
    updateToastPosition: (state, action) => {
      state.position = action.payload;
    },
    updateMaxToasts: (state, action) => {
      state.maxToasts = action.payload;
    },
    updateDefaultDurations: (state, action) => {
      state.defaultDurations = { ...state.defaultDurations, ...action.payload };
    },
    resetToastConfig: () => initialState,
  },
});

export const {
  updateToastConfig,
  updateToastPosition,
  updateMaxToasts,
  updateDefaultDurations,
  resetToastConfig
} = toastConfigSlice.actions;

// Selectors
export const selectToastConfig = state => state.toastConfig;
export const selectToastPosition = state => state.toastConfig.position;
export const selectMaxToasts = state => state.toastConfig.maxToasts;
export const selectDefaultDurations = state => state.toastConfig.defaultDurations;

export default toastConfigSlice.reducer;
